import { createAction } from 'redux-actions';
export const setSeatMap = createAction('SET_SEAT_MAP');
